document.addEventListener("DOMContentLoaded", function () {
  const elementsWithListeners = new Set()

  const handleClick = (event) => {
    dataLayer.push({
      event: "social_content_carousel_click",
      page_location: window.location.href,
    })
  }

  const findElement = () => {
    setTimeout(() => {
      const selectors = [
        ".flex_video_image_main .slick-next",
        ".flex_video_image_main .slick-prev",
        "#slick-slide-control20",
        "#slick-slide-control21",
      ]

      selectors.forEach((selector) => {
        const element = document.querySelector(selector)

        if (element && !elementsWithListeners.has(element)) {
          elementsWithListeners.add(element)
          element.addEventListener("click", handleClick)
        }
      })
    }, 1000)
  }

  const debounce = (func, time) => {
    let timer
    return function (event) {
      if (timer) clearTimeout(timer)
      timer = setTimeout(func, time, event)
    }
  }

  const observer = new MutationObserver(findElement)
  observer.observe(document.body, { childList: true, subtree: true })

  window.addEventListener(
    "resize",
    debounce(() => {
      elementsWithListeners.clear()
      findElement()
    }, 500),
  )
})
